/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import Spinner from "react-bootstrap/Spinner";
import { collection, query, where, getDocs, doc, updateDoc, Timestamp, arrayUnion, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../redux/user/user";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Status from "../../components/status/status";
import ModalAdd from "../../components/addconfirm/model/ModelUser";
import ModalAddE from "../../components/addconfirm/model/editUser";
import { Modal } from "react-bootstrap";
import {
  Menu,
  Dropdown,
  Button,
  message,
  Switch,
  Row,
  Col,
  Avatar,
  Checkbox,
  Tag,
  Input,
} from "antd";
import { Tabs, Tab } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import {
  UserPlus,
  Search,
  Star,
  UserCheck,
  UserX,
  Shield,
  UserCog,
  MoreHorizontal,
  Trash,
  Edit,
  AlertTriangle,
  Clock,
} from "lucide-react";

function Account() {
  const { t, i18n } = useTranslation();
  const [showSideBar, setShowSideBar] = useState(true);
  const [lgShow, setLgShow] = useState(false);
  const [lgShowE, setLgShowE] = useState(false);
  const [show, setShow] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const store = useSelector((state) => state.StoreReducer);
  const [storeData, setStoreData] = useStoreFormDraft(store);
  const [currentItem, setCurrentItem] = useState(null);
  const [tableItems, setTableItems] = useState([]);
  const [invitationStatus, setInvitationStatus] = useState([]);
  const account = useSelector((state) => state.AccountReducer);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("account");
  const [dataForm, setDataForm] = useState({
    name: "",
    email: "",
    phone: "",
    image: "",
    modePayement: "",
    pricing: {
      confirmPrice: 0,
      cancelPrice: 0,
      handByHand: 0,
    },
    addedBy: "",
    role: 3,
    statistics: {
      cancelledOrders: 0,
      confirmedOrders: 0,
    },
    subscription: {
      cash: 0,
      credit: 0,
      plan: "",
      endDate: Timestamp.fromDate(new Date("2023-02-01T00:00:00Z")),
    },
    userId: "",
    maxFoorcall: 0,
  });

  useEffect(() => {
    const fetchAccounts = () => {
      if (account && account.user) {
        const q = query(
          collection(db, "confirmers"),
          where("addedBy", "==", account.user)
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const accounts = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          setTableItems(accounts);
        });

        const invitationQ = query(
          collection(db, "invitations"),
          where("status", "==", 2),
          where("shopUser", "==", account.user)
        );

        const unsubscribeInvitations = onSnapshot(
          invitationQ,
          async (invitationSnapshot) => {
            if (!invitationSnapshot.empty) {
              const confirmUsers = invitationSnapshot.docs.map(
                (doc) => doc.data().confirmUser
              );

              const accountQ = query(
                collection(db, "confirmers"),
                where("user", "in", confirmUsers)
              );

              const accountSnapshot = await getDocs(accountQ);
              const invitationAccounts = accountSnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
              }));
              setInvitationStatus(invitationAccounts);
            }
          }
        );

        return () => {
          unsubscribe();
          unsubscribeInvitations();
        };
      }
    };

    fetchAccounts();
  }, [account]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleEdit = (item) => {
    setDataForm({ ...item, documentId: item.id });
    setLgShowE(true);
  };

  const handleDelete = async (item) => {
    try {
      const docRef = doc(db, "confirmers", item.id);
      await updateDoc(docRef, {
        deleted: true,
      });
      setTableItems(tableItems.filter((tableItem) => tableItem.id !== item.id));

      Swal.fire(t("adduser.confirmer_deleted"), t("adduser.account_permanently_deleted"), "success");
    } catch (error) {
      console.error("Error deleting user: ", error);
      Swal.fire(t("adduser.failed"), t("adduser.try_delete_again"), "error");
    }
  };

  const handleDelete1 = async (item) => {
    try {
      const accountQuery = query(
        collection(db, "confirmers"),
        where("user", "==", item.user)
      );

      const accountSnapshot = await getDocs(accountQuery);
      if (!accountSnapshot.empty) {
        const accountDocRef = accountSnapshot.docs[0].ref;
        await deleteDoc(accountDocRef);
      }

      setInvitationStatus(invitationStatus.filter((inv) => inv.id !== item.id));
      Swal.fire(t("adduser.confirmer_deleted"), t("adduser.work_contract_canceled"), "success");
    } catch (error) {
      console.error("Error deleting invitation: ", error);
      Swal.fire(t("adduser.failed"), t("adduser.error_deleting_invitation"), "error");
    }
  };

  const handleInputChange = (field, value) => {
    setStoreData({ ...storeData, [field]: value });
  };

  const handleNumberChange = (field, value) => {
    setStoreData({ ...storeData, [field]: Number(value) });
  };

  const handleWorkingTimeChange = (field, value) => {
    setStoreData({
      ...storeData,
      workingTime: { ...storeData.workingTime, [field]: value },
    });
  };

  const handleSubmitStore = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveStoreDraft(doc(db, "store", storeData.id), store, storeData);
      Swal.fire({
        icon: "success",
        title: t("adduser.saved_successfully"),
        confirmButtonText: t("ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("adduser.error_saving"),
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleShowRatingModal = (item) => {
    setCurrentItem(item);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleSubmitFeedback = async () => {
    if (account && account.user && currentItem) {
      const docRef = doc(db, "confirmers", currentItem.id);

      const newFeedback = {
        comment: comment,
        rating: rating,
        shopName: account?.name,
        shopImage: account?.img ? account?.img : "",
      };

      try {
        await updateDoc(docRef, {
          "statistics.feedBack": arrayUnion(newFeedback),
        });

        Swal.fire(t("adduser.rated_successfully"), t("adduser.thank_you_rating"), "success");
        setShow(false);
      } catch (error) {
        console.error("Error updating document: ", error);
        Swal.fire(t("adduser.failed"), t("adduser.error_rating"), "error");
      }
    } else {
      console.error("Item is not defined");
      Swal.fire(t("adduser.error"), t("adduser.item_id_not_found"), "error");
    }
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const renderStars = () => {
    return [...Array(5)].map((star, index) => {
      return (
        <svg
          key={index}
          className={`w-6 h-6 cursor-pointer ${index < rating ? "text-amber-400" : "text-gray-300"
            }`}
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 22 20"
          onClick={() => setRating(index + 1)}
        >
          <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
        </svg>
      );
    });
  };

  const handleEditDateTime = async (itemId, newDate, newTime) => {
    if (newDate && newTime) {
      try {
        const itemRef = doc(db, "confirmers", itemId);

        const source = tableItems.find((item) => item.id === itemId)
          ? tableItems
          : invitationStatus;

        const originalProducts = source.find(
          (item) => item.id === itemId
        )?.products;

        if (!originalProducts || !Array.isArray(originalProducts)) {
          throw new Error("Products array is undefined or invalid.");
        }

        const updatedProducts = originalProducts.map((product) => {
          if (product.beginDate) {
            return {
              ...product,
              beginDate: Timestamp.fromDate(new Date(`${newDate}T${newTime}`)),
            };
          }
          return product;
        });

        const sanitizedProducts = updatedProducts.filter(
          (product) => product !== undefined
        );

        await updateDoc(itemRef, {
          products: sanitizedProducts,
        });

        Swal.fire(t("adduser.updated_successfully"), t("adduser.date_time_updated"), "success");
      } catch (error) {
        console.error("Error updating beginDate:", error);
        Swal.fire(t("adduser.failed"), t("adduser.error_updating_date_time"), "error");
      }
    }
  };

  const totalConfirmers = tableItems.length + invitationStatus.length;
  const ownConfirmers = tableItems.length;
  const externalConfirmers = invitationStatus.length;
  const isRTL = i18n.language === 'ar';
  return (
    <div
      className="container-fluid bg-white to-purple-50 min-h-screen dark:!bg-[#141414]" dir={isRTL ? 'rtl' : 'ltr'}

    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div className="px-3 dark:!bg-[#141414]" style={{ flex: 1, backgroundColor: "#fbf8fc" }}>
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("adduser.manage_confirmers")}
                </h2>
                <p className="text-gray-600 dark:text-gray-300 mb-0">
                  {t("adduser.monitor_manage_confirmers")}
                </p>
              </div>
              <button
                onClick={() => setLgShow(true)}
                className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-6 py-2 rounded-lg transition-colors flex items-center"
              >
                <UserPlus size={18} />
                <span className="mr-1">{t("adduser.add_new_confirmer")}</span>
              </button>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex">
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "account"
                    ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                    : "text-gray-600 hover:bg-[#6e358c] dark:text-gray-300 "
                    }`}
                  onClick={() => setActiveTab("account")}
                >
                  {t("adduser.confirmer_team")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab2"
                    ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                    : "text-gray-600 hover:bg-[#6e358c] dark:text-gray-300 "
                    }`}
                  onClick={() => setActiveTab("tab2")}
                >
                  {t("adduser.confirmation_settings")}
                </button>
              </div>
            </div>
          </div>

          {/* Status Cards */}
          {activeTab === "account" && (
            <div className="mx-3 mb-4 overflow-x-auto pb-2">
              <div className="flex md:grid md:grid-cols-3 gap-3">
                <div className="flex-shrink-0 w-60 justify-between md:w-auto flex items-center p-3 bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all">
                  <div className="w-8 h-8 rounded-lg bg-[#faf1ff] dark:!bg-[#181819] flex items-center justify-center mr-3">
                    <UserCheck size={18} className="text-[#9e68ba]" />
                  </div>
                  <div className="text-end mx-2">
                    <div className="text-sm font-medium text-gray-800 dark:!text-gray-200">
                      {t("adduser.all_confirmers")}
                    </div>
                    <div className="font-bold text-[#9e68ba]">
                      {totalConfirmers}
                    </div>
                  </div>
                </div>

                <div className="flex-shrink-0 w-60 justify-between md:w-auto flex items-center p-3 bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all">
                  <div className="w-8 h-8 rounded-lg bg-[#faf1ff] dark:!bg-[#181819] flex items-center justify-center mr-3">
                    <UserCog size={18} className="text-[#9e68ba]" />
                  </div>
                  <div className="text-end mx-2">
                    <div className="text-sm font-medium text-gray-800 dark:!text-gray-200">
                      {t("adduser.own_confirmers")}
                    </div>
                    <div className="font-bold text-[#9e68ba]">
                      {ownConfirmers}
                    </div>
                  </div>
                </div>

                <div className="flex-shrink-0 w-60 justify-between md:w-auto flex items-center p-3 bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] hover:shadow-md transition-all">
                  <div className="w-8 h-8 rounded-lg bg-[#faf1ff] dark:!bg-[#181819] flex items-center justify-center mr-3">
                    <UserX size={18} className="text-[#9e68ba]" />
                  </div>
                  <div className="text-end mx-2">
                    <div className="text-sm font-medium text-gray-800 dark:!text-gray-200">
                      {t("adduser.external_confirmers")}
                    </div>
                    <div className="font-bold text-[#9e68ba]">
                      {externalConfirmers}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Search and Filter Bar */}
          {activeTab === "account" && (
            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 mx-3 mb-4 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="relative flex-grow max-w-xl">
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <Search size={16} className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    className="bg-gray-50 dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full pr-10 p-2.5 focus:outline-none focus:ring-2 focus:ring-purple-200"
                    placeholder={t("adduser.search_confirmer")}
                  />
                </div>

                <div className="flex flex-row items-center gap-x-4">
                  <div className="opacity-0 flex items-center gap-3">
                    <select
                      className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg p-2.5 focus:ring-purple-200 focus:border-purple-500"
                    >
                      <option value={5}>{t("adduser.five_products")}</option>
                      <option value={10}>{t("adduser.ten_products")}</option>
                      <option value={25}>{t("adduser.twenty_five_products")}</option>
                      <option value={50}>{t("adduser.fifty_products")}</option>
                      <option value={100}>{t("adduser.hundred_products")}</option>
                    </select>
                  </div>
                  <button
                    onClick={() => setLgShow(true)}
                    className="bg-[#9b59bf] hover:bg-[#814a9f]  text-white px-6 py-2 rounded-lg transition-colors flex items-center"
                  >
                    <UserPlus size={18} />
                    <span className="mr-1">{t("adduser.add_new_confirmer")}</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Main Content - Confirmers Table */}
          {activeTab === "account" && (
            <div className="mx-3 bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] p-0 mb-6 overflow-hidden">
              <table className="w-full table-auto text-sm text-left">
                <thead className="bg-[#fcf6ff] dark:!bg-[#1e1e1e] text-[#9e68ba] font-medium border-b border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <tr>
                    <th className="py-3 px-6 text-center">{t("adduser.confirmer")}</th>
                    <th className="py-3 px-6 text-center">{t("adduser.phone_number")}</th>
                    <th className="py-3 px-6 text-center">{t("adduser.confirm_price")}</th>
                    <th className="py-3 px-6 text-center">{t("adduser.cancel_price")}</th>
                    <th className="py-3 px-6 text-center">{t("adduser.join_date")}</th>
                    <th className="py-3 px-6 text-center">{t("adduser.actions")}</th>
                  </tr>
                </thead>

                <tbody className="text-gray-600 divide-y">
                  {tableItems.map(
                    (item, idx) =>
                      item.deleted !== true && (
                        <tr
                          key={idx}
                          className="hover:bg-[#fcf6ff] dark:hover:bg-[#1e1e1e] transition-colors"
                        >
                          {/* Image + nom */}
                          <td className="flex items-center justify-center gap-x-3 py-3 px-6 whitespace-nowrap">
                            <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] flex items-center justify-center overflow-hidden">
                              <img
                                src="/icons-2.png"
                                className="w-10 h-10 object-cover"
                                alt={item.name}
                              />
                            </div>
                            <div className="text-center">
                              <span className="block text-gray-800 text-sm font-medium dark:text-gray-200">
                                {item.name}
                              </span>
                              <span className="block text-gray-500 text-xs dark:text-gray-200">{item.email}</span>
                            </div>
                          </td>

                          {/* Téléphone */}
                          <td className="py-3 px-4 text-center whitespace-nowrap dark:text-gray-200">
                            {item.phone}
                          </td>

                          {/* Prix confirmé */}
                          <td className="py-3 px-4 text-center whitespace-nowrap">
                            <span className="font-medium text-gray-900 dark:text-gray-200">
                              {item?.pricing?.confirmPrice ? item?.pricing?.confirmPrice : 0}
                            </span>
                          </td>

                          {/* Prix annulé */}
                          <td className="py-3 px-4 text-center whitespace-nowrap">
                            <span className="font-medium text-gray-900 dark:text-gray-200">
                              {item?.pricing?.cancelPrice ? item?.pricing?.cancelPrice : 0}
                            </span>
                          </td>

                          <td className="py-3 px-4 text-center whitespace-nowrap">
                            {item.products &&
                              item.products.map((product, index) => {
                                const beginDate = product?.beginDate?.toDate
                                  ? product.beginDate.toDate()
                                  : null;

                                const formattedDate = beginDate
                                  ? beginDate.toISOString().split("T")[0]
                                  : "";
                                const formattedTime = beginDate
                                  ? beginDate.toISOString().split("T")[1].substring(0, 5)
                                  : "";

                                return (
                                  <div
                                    key={index}
                                    className="flex items-center justify-center gap-x-2 mb-2"
                                  >
                                    <input
                                      type="date"
                                      defaultValue={formattedDate}
                                      onChange={(e) =>
                                        handleEditDateTime(item.id, e.target.value, formattedTime)
                                      }
                                      className="border border-purple-200 dark:border-[#3c3a3d] rounded px-2 py-1 mr-2 text-sm bg-white dark:bg-[#1e1e1e] text-gray-700  focus:border-purple-500 focus:ring-1 focus:ring-purple-200 dark:focus:ring-[#9e68ba]"
                                    />
                                    <input
                                      type="time"
                                      defaultValue={formattedTime}
                                      onChange={(e) =>
                                        handleEditDateTime(item.id, formattedDate, e.target.value)
                                      }
                                      className="border border-purple-200 dark:border-[#3c3a3d] rounded px-2 py-1 text-sm  bg-white dark:bg-[#1e1e1e] text-gray-700 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 dark:focus:ring-[#9e68ba]"
                                    />
                                  </div>
                                );
                              })}
                          </td>

                          <td className="px-6 py-3 text-center">
                            <div className="flex justify-center dark:!bg-[#1e1e1e]">
                              <Dropdown
                                overlay={
                                  <Menu className="right-to-left dark:!bg-[#1e1e1e] dark:!border-[#3c3a3d]">
                                    <Menu.Item
                                      key="1"
                                      onClick={() => handleShowRatingModal(item)}
                                    >
                                      <div className="flex items-center text-amber-600 px-2">
                                        <Star size={16} className="ml-2" />
                                        <span>{t("adduser.rate")}</span>
                                      </div>
                                    </Menu.Item>
                                    <Menu.Item key="2" onClick={() => handleDelete1(item)}>
                                      <div className="flex items-center text-red-600 px-2">
                                        <Trash size={16} className="ml-2" />
                                        <span>{t("adduser.delete")}</span>
                                      </div>
                                    </Menu.Item>
                                  </Menu>
                                }
                                trigger={["click"]}
                              >
                                <button className="p-1 rounded-full hover:bg-[#faf1ff] dark:hover:bg-[#2a2a2a] transition-colors">
                                  <MoreHorizontal
                                    size={20}
                                    className="text-[#9e68ba] dark:text-[#b57ed8]"
                                  />
                                </button>
                              </Dropdown>
                            </div>
                          </td>

                        </tr>
                      )
                  )}
                </tbody>

              </table>
            </div>
          )}

          {/* Settings Tab */}
          {activeTab === "tab2" && (
            <div className="mx-3 mb-6">
              <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
                <div className="mb-6">
                  <h2 className="text-xl font-bold text-[#9e68ba] mb-3">
                    {t("adduser.order_protection_settings")}
                  </h2>
                  <p className="text-gray-600 mb-6">
                    {t("adduser.customize_protection_settings")}
                  </p>

                  <div className="grid grid-cols-1 gap-5">
                    <div className="flex items-center justify-between p-4 border border-[#fbf4ff] rounded-lg hover:bg-[#fcf6ff] transition-all">
                      <div className="flex items-center gap-x-2">
                        <div className="w-10 h-10 rounded-lg bg-[#faf1ff] flex items-center justify-center mr-3">
                          <Shield size={18} className="text-[#9e68ba]" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">
                            {t("adduser.prevent_add_orders")}
                          </p>
                          <p className="text-sm text-gray-500">
                            {t("adduser.protection_unauthorized_additions")}
                          </p>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        id="custom-switch1"
                        checked={!storeData.addOrdersByConfirm}
                        onChange={(e) =>
                          handleInputChange(
                            "addOrdersByConfirm",
                            !e.target.checked
                          )
                        }
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500 scale-125"
                      />
                    </div>

                    <div className="flex items-center justify-between p-4 border border-[#fbf4ff] rounded-lg hover:bg-[#fcf6ff] transition-all">
                      <div className="flex items-center gap-x-2">
                        <div className="w-10 h-10 rounded-lg bg-[#faf1ff] flex items-center justify-center mr-3">
                          <Shield size={18} className="text-[#9e68ba]" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">
                            {t("adduser.prevent_edit_orders")}
                          </p>
                          <p className="text-sm text-gray-500">
                            {t("adduser.enhance_protection_unauthorized_edits")}
                          </p>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        id="custom-switch2"
                        checked={!storeData.editOrdersByConfirm}
                        onChange={(e) =>
                          handleInputChange(
                            "editOrdersByConfirm",
                            !e.target.checked
                          )
                        }
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500 scale-125"
                      />
                    </div>

                    <div className="flex items-center justify-between p-4 border border-[#fbf4ff] rounded-lg hover:bg-[#fcf6ff] transition-all">
                      <div className="flex items-center gap-x-2">
                        <div className="w-10 h-10 rounded-lg bg-[#faf1ff] flex items-center justify-center mr-3">
                          <AlertTriangle size={18} className="text-[#9e68ba]" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">
                            {t("adduser.confirm_old_orders_first")}
                          </p>
                          <p className="text-sm text-gray-500">
                            {t("adduser.mandatory_old_order_confirmation")}
                          </p>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        id="custom-switch3"
                        checked={storeData.priorityOrders}
                        onChange={(e) =>
                          handleInputChange("priorityOrders", e.target.checked)
                        }
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500 scale-125"
                      />
                    </div>

                    <div className="flex items-center justify-between p-4 border border-[#fbf4ff] rounded-lg hover:bg-[#fcf6ff] transition-all">
                      <div className="flex items-center gap-x-2">
                        <div className="w-10 h-10 rounded-lg bg-[#faf1ff] flex items-center justify-center mr-3">
                          <AlertTriangle size={18} className="text-[#9e68ba]" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">
                            {t("adduser.mandatory_status_change")}
                          </p>
                          <p className="text-sm text-gray-500">
                            {t("adduser.must_update_status")}
                          </p>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        id="custom-switch4"
                        checked={storeData.isMustChange}
                        onChange={(e) =>
                          handleInputChange("isMustChange", e.target.checked)
                        }
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500 scale-125"
                      />
                    </div>

                    <div className="flex items-center justify-between p-4 border border-[#fbf4ff] rounded-lg hover:bg-[#fcf6ff] transition-all">
                      <div className="flex items-center gap-x-2">
                        <div className="w-10 h-10 rounded-lg bg-[#faf1ff] flex items-center justify-center mr-3">
                          <AlertTriangle size={18} className="text-[#9e68ba]" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">
                            {t("adduser.enable_max_attempts")}
                          </p>
                          <p className="text-sm text-gray-500">
                            {t("adduser.set_max_contact_attempts")}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="number"
                          value={storeData.numberOfTentative || ""}
                          onChange={(e) =>
                            handleNumberChange(
                              "numberOfTentative",
                              e.target.value
                            )
                          }
                          min="1"
                          max="20"
                          placeholder="10"
                          className="border border-purple-200 rounded px-3 py-1 w-16 text-center focus:border-purple-500 focus:ring-1 focus:ring-purple-200"
                        />
                        <span className="mr-2 text-gray-600">{t("adduser.times")}</span>
                      </div>
                    </div>

                    <div className="flex items-center justify-between p-4 border border-[#fbf4ff] rounded-lg hover:bg-[#fcf6ff] transition-all">
                      <div className="flex items-center gap-x-2">
                        <div className="w-10 h-10 rounded-lg bg-[#faf1ff] flex items-center justify-center mr-3">
                          <Clock size={18} className="text-[#9e68ba]" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">
                            {t("adduser.confirmation_working_hours")}
                          </p>
                          <p className="text-sm text-gray-500">
                            {t("adduser.set_allowed_confirmation_times")}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <div className="flex items-center">
                          <span className="ml-2 text-gray-600 text-sm">
                            {t("adduser.from")}
                          </span>
                          <input
                            type="time"
                            value={storeData.workingTime?.beginTime || "09:00"}
                            onChange={(e) =>
                              handleWorkingTimeChange(
                                "beginTime",
                                e.target.value
                              )
                            }
                            className="border border-purple-200 rounded px-2 py-1 w-24 text-sm focus:border-purple-500 focus:ring-1 focus:ring-purple-200"
                          />
                        </div>
                        <div className="flex items-center mr-4">
                          <span className="ml-2 text-gray-600 text-sm">
                            {t("adduser.to")}
                          </span>
                          <input
                            type="time"
                            value={storeData.workingTime?.endTime || "17:00"}
                            onChange={(e) =>
                              handleWorkingTimeChange("endTime", e.target.value)
                            }
                            className="border border-purple-200 rounded px-2 py-1 w-24 text-sm focus:border-purple-500 focus:ring-1 focus:ring-purple-200"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 flex justify-end">
                    <button
                      className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-6 py-2 rounded-lg transition-colors flex items-center"
                      onClick={handleSubmitStore}
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="ml-2"
                        />
                      ) : (
                        <Shield size={18} className="ml-2" />
                      )}
                      <span>{t("adduser.save_settings")}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Rating Modal */}
          <Modal
            show={show}
            onHide={handleClose}
            centered
            contentClassName="rounded-lg border-0"
          >
            <Modal.Header
              closeButton

              className="border-0 bg-[#fcf6ff] rounded-t-lg"
            >
              <Modal.Title className="text-[#9e68ba] font-bold">
                {t("adduser.rate_confirmer_performance")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-5">
              <div className="flex flex-col items-center justify-center mb-4">
                <div className="w-20 h-20 rounded-full bg-[#faf1ff] flex items-center justify-center mb-3 overflow-hidden">
                  <img
                    src="/icons-2.png"
                    alt={t("ui.profile")}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h4 className="text-lg font-medium text-gray-800 mb-1">
                  {currentItem?.name || t("adduser.confirmer_name")}
                </h4>
                <div className="flex justify-center gap-1 my-3">
                  {renderStars()}
                </div>
                <div className="text-[#9e68ba] font-medium mb-3">
                  {t("adduser.rating_out_of_five", { rating })}
                </div>
                <textarea

                  placeholder={t("adduser.enter_comment")}
                  value={comment}
                  onChange={handleCommentChange}
                  rows="4"
                  required
                  className="w-full mt-2 h-36 px-4 py-3 resize-none appearance-none bg-gray-50 outline-none border border-purple-200 focus:border-purple-500 focus:ring-1 focus:ring-purple-200 rounded-lg"
                ></textarea>
              </div>
            </Modal.Body>
            <Modal.Footer

              className="border-0 bg-gray-50 rounded-b-lg"
            >
              <Button
                variant="outline-secondary"
                onClick={handleClose}
                className="bg-gray-200 text-gray-800 border-0 hover:bg-gray-300 transition-colors rounded-lg px-4 py-2"
              >
                {t("adduser.cancel")}
              </Button>
              <Button
                onClick={() => handleSubmitFeedback()}
                className="bg-[#9b59bf] text-white border-0 hover:bg-[#814a9f] transition-colors rounded-lg px-4 py-2 mr-2"
              >
                {t("adduser.submit_rating")}
              </Button>
            </Modal.Footer>
          </Modal>

          <ModalAdd
            lgShow={lgShow}
            setLgShow={setLgShow}
            dataForm={dataForm}
            setDataForm={setDataForm}
          />
          <ModalAddE
            lgShowE={lgShowE}
            setLgShowE={setLgShowE}
            dataForm={dataForm}
            setDataForm={setDataForm}
          />

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Account;